/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransferReport } from './TransferReport';
import {
    TransferReportFromJSON,
    TransferReportFromJSONTyped,
    TransferReportToJSON,
} from './TransferReport';

/**
 * 
 * @export
 * @interface ListTransferReportsResponseBody
 */
export interface ListTransferReportsResponseBody {
    /**
     * 
     * @type {Array<TransferReport>}
     * @memberof ListTransferReportsResponseBody
     */
    items: Array<TransferReport>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListTransferReportsResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListTransferReportsResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListTransferReportsResponseBody interface.
 */
export function instanceOfListTransferReportsResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListTransferReportsResponseBodyFromJSON(json: any): ListTransferReportsResponseBody {
    return ListTransferReportsResponseBodyFromJSONTyped(json, false);
}

export function ListTransferReportsResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTransferReportsResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TransferReportFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListTransferReportsResponseBodyToJSON(value?: ListTransferReportsResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(TransferReportToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

